import { useAuth0 } from '@auth0/auth0-react';

/**
 * Hook to get the access token for API requests
 * This will automatically handle token refresh
 */
export const useAuthToken = () => {
  const { getAccessTokenSilently, logout, isAuthenticated, isLoading } = useAuth0();

  const getToken = async (): Promise<string | null> => {
    
    if (!isAuthenticated) {
      return null;
    }

    if (isLoading) {
      // Wait a bit for auth to finish
      await new Promise(resolve => setTimeout(resolve, 500));
    }

    try {
      const audience = process.env.REACT_APP_AUTH0_AUDIENCE || '';
      
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: audience,
          scope: 'openid profile email offline_access', // Agregar offline_access
        },
        cacheMode: 'on', // Mejorar el manejo del cache de tokens
      });
      
      if (token) {
      } else {
      }
      
      return token;
    } catch (error: any) {
      if (
        error?.error === 'interaction_required' ||
        error?.error === 'missing_refresh_token' ||
        error?.message?.includes('Missing Refresh Token')
      ) {
        localStorage.clear();
        sessionStorage.clear();
        logout({ logoutParams: { returnTo: window.location.origin } });
        return null;
      }
      return null;
    }
  };

  return { getToken, isAuthenticated, isLoading };
};


